import { useContext } from "react";
import { PortalCtx } from "./PortalContext";

export const usePortalContainer = () => useContext(PortalCtx);
